import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/product-hunt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M326.3 218.8c0 20.5-16.7 37.2-37.2 37.2h-70.3v-74.4h70.3c20.5 0 37.2 16.7 37.2 37.2zM504 256c0 137-111 248-248 248s-248-111-248-248 111-248 248-248 248 111 248 248zM375.9 218.8c0-47.9-38.9-86.8-86.8-86.8h-119.9v248h49.6v-74.4h70.3c47.9 0 86.8-38.9 86.8-86.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/product-hunt.js
// module id = 977
// module chunks = 0